import { useState, useEffect } from 'react';
import { isBrowser } from '@utils';

export function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState<number | 0>(0);

  useEffect(() => {
    let animationFrame: any;

    if (isBrowser()) {
      setWindowWidth(window.innerWidth);

      const handleResize = () => {
        setWindowWidth(window.innerWidth);
        animationFrame = window.requestAnimationFrame(() => {});
      };

      window.addEventListener('resize', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        window.cancelAnimationFrame(animationFrame);
      };
    }
  });

  return windowWidth;
}
